
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../../../shared/shared-imports';
import { OptionTranslateService } from '../../../../../shared/services/option-translate.service';
import { customValidator } from '../../../../../Utils/validator';
import { LookupKey } from '../../../../../shared/constants/lookup-keys';
import { Utils } from '../../../../../Utils/utils';
import { ServiceName } from '../../../../../shared/constants/services.enum';

@Component({
  standalone: true,
  selector: 'app-add-consignee',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './add-consignee.component.html',
  styleUrl: './add-consignee.component.scss'
})
export class AddConsigneeComponent implements OnChanges {
  @Input() isOpen = false;
  @Input() selectedConsignee: any = "";
  @Input() srSubType: any = ""

  @Output() isOpenChange = new EventEmitter<boolean>();
  @Output() onBtnClick = new EventEmitter<any>();

  form: FormGroup;
  countries: any = [];
  cities: any = [{ label: "Dubai", value: 1 }];
  LookupKey: any = LookupKey;
  isGSPCertificate: boolean = false;

  // This method is used to initialize the class instance using fb and option translate service
  constructor(
    private fb: FormBuilder,
    private optionTranslateService: OptionTranslateService
  ) {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(100), customValidator('customSafeText')]],
      country: [null, [Validators.required]],
      city: [null, [Validators.maxLength(50), customValidator('customSafeText')]],
      countryCode: [null],
      phone: ['', [Validators.maxLength(15), customValidator('mobile')]],
      address: ['', [Validators.required, Validators.maxLength(110), customValidator('customSafeText')]],
      poBox: ['', [Validators.maxLength(30), customValidator('customSafeText')]],
      fax: ['', [Validators.maxLength(30), customValidator('customSafeText')]]
    });
    this.countries = this.optionTranslateService.getOptions(
      'nationalities',
      'en'
    );
  }
  // This method is used to handle the on changes lifecycle hook using changes
  ngOnChanges(changes: SimpleChanges): void {
    if (this.srSubType == ServiceName.ISSUE_GSP_COO) {
      this.isGSPCertificate = true;
    }
    if (this.selectedConsignee?.formFields) {
      this.form.patchValue(this.selectedConsignee.formFields);
    }

  }
  // This method is used to add
  add() {
    const phoneValue = (this.form.get('phone')?.value || '').toString().trim();
    const countryCodeControl = this.form.get('countryCode');
    if (phoneValue && !countryCodeControl?.value) {
      const existingValidators = (countryCodeControl as any)?._rawValidators || [];
      countryCodeControl?.setValidators([Validators.required, ...existingValidators]);
      countryCodeControl?.updateValueAndValidity({ emitEvent: false });
      countryCodeControl?.setErrors({ ...(countryCodeControl.errors || {}), required: true });
      countryCodeControl?.markAsTouched();
      countryCodeControl?.markAsDirty();
      this.form.get('phone')?.markAsTouched();
    }

    const invalidControls = Utils.getInvalidControls(this.form);
    console.warn('Invalid controls:', invalidControls);
    if (this.form.valid) {
      this.onBtnClick.emit(this.form.value);
      this.isOpenChange.emit(false);
      this.isOpen = false;
    } else {
      this.form.markAllAsTouched();
    }
  }
  // This method is used to close
  close() {
    this.isOpenChange.emit(false);
    this.isOpen = false;
  }
}
